import actionTypes from '../constants/action-types';

const setSiteProperties = (properties) => ({
  type: actionTypes.SET_SITE_PROPERTIES,
  payload: {
    properties,
  },
});

export default setSiteProperties;
